import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnotifyService, ToastDefaults } from 'ng-snotify';
import { EquipmentService } from '../../../../services/equipment.service';
import { Equipment } from '../../../../models/equipment';

@Component({
  selector: 'app-asset-manage',
  templateUrl: './asset-manage.component.html',
  styleUrls: ['./asset-manage.component.scss']
})
export class AssetManageComponent implements OnInit {

  id: string = null;
  equip: any;
  companyId: number = 0;
  editMode: boolean = false;
  constructor(private router: Router, private route: ActivatedRoute, private snotifyService: SnotifyService, public equipmentService: EquipmentService) { }

  ngOnInit(): void {
    this.equip = new Equipment();

    var id = this.router.parseUrl(this.router.url).queryParams["id"];
    if (id != null) {
      this.equipmentService.get(id).then((e) => {
        this.equip = e;
        this.editMode = true;
      });
    }
  }

  back() {
    this.router.navigate(['admin/assets']);
  }

  validate() {
    if (this.equip.company_Id == null || this.equip.company_Id == "" || this.equip.company_Id == 0) {
      this.snotifyService.error("Please enter a Company");
      return false;
    }
    if (this.equip.location_Id == null || this.equip.location_Id == "" || this.equip.location_Id == 0) {
      this.snotifyService.error("Please enter a Location");
      return false;
    }
 

    if (this.equip.description == null || this.equip.description == "") {
      this.snotifyService.error("Please enter a description");
      return false;
    }
    if (this.equip.serial_Num == null || this.equip.serial_Num == "") {
      this.snotifyService.error("Please enter a Serial #");
      return false;
    }

    if (this.equip.make == null || this.equip.make == "") {
      this.snotifyService.error("Please enter a make");
      return false;
    }


    if (this.equip.report_Type_Id == null || this.equip.report_Type_Id == "" || this.equip.report_Type_Id == 0) {
      this.snotifyService.error("Please enter a report type");
      return false;
    }

    if (this.equip.report_Type_Id != 5 && this.equip.report_Type_Id != 16 && (this.equip.swl == null || this.equip.report_Type_Id == "" || this.equip.report_Type_Id == 0))
    {
      this.snotifyService.error("Please enter a safe working load");
      return false;
    }
    return true;
  }

  async save() {
    if (!this.validate()) {
      return;
    }
    //console.log(this.equip);

    if (!this.editMode)
      await this.equipmentService.add(this.equip);
    else
      await this.equipmentService.update(this.equip);

    this.router.navigate(['admin/assets']);
  }

  async delete() {
    await this.equipmentService.delete(this.id);
    this.router.navigate(['admin/assets']);
  }

  onCompanyChange(value) {
    if (value == undefined)
      this.equip.company_Id = undefined;
    else
      this.equip.company_Id = value.id;

  }



  onLocationChange(value) {
    if (value == undefined)
      this.equip.location_Id = undefined;
    else
      this.equip.location_Id = value.id;

  }

  onCategoryChange(value) {
    if (value == undefined)
      this.equip.categoryId = undefined;
    else
      this.equip.categoryId = value.id;
  }

  onReportTypeChange(value) {
    if (value == undefined)
      this.equip.report_Type_Id = undefined;
    else
      this.equip.report_Type_Id = value.id;
  }
  onDescriptionChange(value) {
    if (value == undefined) {
      this.equip.item_Code = undefined;
      this.equip.description = undefined;
    } else {
      this.equip.item_Code = value.id;
      this.equip.description = value.description;
    }
  }

  setCompanyId(company) {
    //console.log(company);
    if (company.id != null) {
      this.companyId = company.id;
    }
  }
}
